import { render, staticRenderFns } from "./InfoSection.vue?vue&type=template&id=9373d85c&scoped=true&"
import script from "./InfoSection.vue?vue&type=script&lang=ts&"
export * from "./InfoSection.vue?vue&type=script&lang=ts&"
import style0 from "./InfoSection.vue?vue&type=style&index=0&id=9373d85c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9373d85c",
  null
  
)

export default component.exports